import React, { useEffect, useId, useState } from 'react';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { useAppSelector } from '../../hooks/redux';
import { Divider } from 'antd';
import { ProductDetailsProps } from '../interfaces';
import Spinner from '../spinner';
import './productDetails.scss';

const ProductDetails: React.FC<ProductDetailsProps> = ({  value }) => {
  const [selectedMaterial, setSelectedMaterial] = useState(value || '');
  const [isLoading] = useState(false);
  const [error] = useState<string | null>(null);
  const productDetails = useAppSelector((state) => state.curProduct.productDetails?.product.details);
  const productType = useAppSelector((state) => state.curProduct.productDetails?.product.productType?.name);
  const [isOpen, setIsOpen] = useState(false);
  const panelId = useId();
  const triggerId = useId();
  
  useEffect(() => {
    setSelectedMaterial(value || '');
  }, [value]);
  
  const toggleDropdown = () => {
    setIsOpen(prev => !prev);
};

  const formatProductType = (type: string | undefined) => {
    if (type) {
      const formattedType = type.endsWith('s') ? type.slice(0, -1) : type;
      return formattedType.toUpperCase();
    }
    return '';
  };

  return (
    <div className="dropdown-container">
      <Divider />
      <button
        type="button"
        id={triggerId}
        className="product-header"
        onClick={toggleDropdown}
        aria-expanded={isOpen}
        aria-controls={panelId}
      >
        <span className="product-title">Product Details</span>
        {isOpen
          ? <UpOutlined className="dropdown-icon" aria-hidden="true" />
          : <DownOutlined className="dropdown-icon" aria-hidden="true" />}
      </button>
      <Divider className={`divider-transition ${isOpen ? 'hidden' : ''}`} />
      <div
        id={panelId}
        className={`dropdown-menu ${isOpen ? 'open' : ''}`}
        role="region"
        aria-labelledby={triggerId}
        aria-hidden={!isOpen}
      >
        <span className="title-details">
          {isLoading ? <Spinner /> : formatProductType(productType) + " INFORMATION"}
          {productDetails === null && (
            <div style={{ color: "red", marginTop: "4px" }}>Data unavailable</div>
          )}
        </span>
        <Divider style={{ marginTop: '10px' }} />
        <ul>
          {isLoading ? (
            <li><Spinner /></li>
          ) : error ? (
            <li>{error}</li>
          ) : productDetails ? (
            <>
              <li>Style: {productDetails.style}</li>
              <li>Metal: {selectedMaterial || productDetails.metal}</li>
              <li>Width: {productDetails.width}</li>
              <li>Length: {productDetails.length}</li>
              <li>Setting: {productDetails.setting}</li>
              <li>Backing: {productDetails.backing}</li>
              <Divider className={`divider-transition ${isOpen ? 'open' : 'hidden'}`} />
            </>
          ) : null}
        </ul>
      </div>
    </div>
  );
};

export default ProductDetails;
